import useCasMutation, {
  GenericMutationProps,
} from 'src/compass/shared/hooks/reactQuery/useCasMutation';

type uploadMutationProps = GenericMutationProps & { url: string };

export default function useUploadMutation({ url, ...rest }: uploadMutationProps) {
  return useCasMutation({
    includesAttachment: true,
    method: 'post',
    url,
    ...rest,
  });
}
